// constants.js
export const monthUa = [
  'січень', 'лютий', 'березень', 'квітень', 'травень', 'червень',
  'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень'
];

export const ukrDaysName = ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

export const holyDaysEvery = [
  [1, 7], [], [8], [], [1, 9], [28], [28], [24], [], [14], [], [25]
];


export  const groupTypes = [
    {
      "number": 1, "ageLimitFrom": 0, "ageLimitTo": 1,
      "description": "Перша група раннього віку — від двох місяців до року (до 10 осіб)"
    },
    {
      "number": 2, "ageLimitFrom": 1, "ageLimitTo": 2,
      "description": "Друга група раннього віку — від 1-го до 2-х років (до 15 осіб)"
    },
    {
      "number": 3, "ageLimitFrom": 2, "ageLimitTo": 3,
      "description": "Перша молодша група — від 2-х до 3-х років (до 15 осіб)"
    },
    {
      "number": 4, "ageLimitFrom": 3, "ageLimitTo": 4,
      "description": "Друга молодша група — від 3-х до 4-х років (до 20 осіб)"
    },
    {
      "number": 5, "ageLimitFrom": 4, "ageLimitTo": 5,
      "description": "Середня група — від 4-х до 5-ти років (до 20 осіб)"
    },
    {
      "number": 6, "ageLimitFrom": 5, "ageLimitTo": 6,
      "description": "Старша група — від 5-ти до 6-ти років (до 20 осіб)"
    },
    {
      "number": 7, "ageLimitFrom": 6, "ageLimitTo": 7,
      "description": "Підготовча до школи група — від 6-ти до 7-ми років (до 20 осіб)"
    },
    {
      "number": 8, "ageLimitFrom": 3, "ageLimitTo": 5,
      "description": "Різновікова"
    },
    {
      "number": 10, "ageLimitFrom": 3, "ageLimitTo": 5,
      "description": "Різновікова — від 3-х до 5-ти років"
    },
    {
      "number": 11, "ageLimitFrom": 3, "ageLimitTo": 6,
      "description": "Різновікова — від 3-х до 6-ти років"
    },
    {
      "number": 12, "ageLimitFrom": 4, "ageLimitTo": 6,
      "description": "Різновікова — від 4-х до 6-ти років"
    },
    {
      "number": 13, "ageLimitFrom": 0, "ageLimitFromPlusMonth": 6, "ageLimitTo": 1,
      "description": "Від 6 місяців до 1 року"
    },
    {
      "number": 14, "ageLimitFrom": 1, "ageLimitFromPlusMonth": 6, "ageLimitTo": 3,
      "description": "Від 1 року і 6 місяців до 3 років"
    }
  ];

export const TYPE_SANAORNIY = 'Санаторна';

export const normalPlaceForGorups = {
            wo_spec: {
                2: 15,
                3: 15,
                4: 20,
                5: 20,
                6: 20,
                11:15,
                14:15,
                default: 15 
            },
            short: 10,
            spec:{
                "з короткотривалим і цілодобовим перебуванням дітей":10,  
                "із складними вадами розвитку, глухі, сліпі":6,
                "зі зниженням слуху":8,
                "з порушенням опорно-рухового апарату":8,
                "глибоко розумово відсталі":8,
                "з важкими порушеннями мови":10,
                "з затримкою психічного розвитку":10,
                "із затримкою психічного розвитку": 10,
                "із зниженням зору, косоокістю і амбліопією":10,
                "розумово відсталих":10, 
                "хворих на сколіоз":10,
                "з фонетико-фонематичним недорозвитком мови": 12,
                "Загальний недорозвиток мовлення": 10,
                "з розумовою відсталістю": 10,
                "з порушеннями слуху (глухих, зі зниженим слухом)": 8,
                "з хронічними неспецифічними захворюваннями органів дихання": 10,
                "Фонетико-фонематичне недорозвинення мови": 12,
                "з порушеннями опорно-рухового апарату":8,
                "з хворобами органів травлення": 10,
                "з порушеннями зору (сліпих, зі зниженим зором)": 10,
                "з латентною туберкульозною інфекцією та після вилікування від туберкульозу": 10,
                default: 10 
            },
            sanat:{
                1:15,
                2:15,
                3:15,
                9:15,
                10:15,
                11:15,
                12:15,
                13:15,
                14: 15,
                default: 20
            }
        }

